import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DEFAULT_MAX_TASK_COUNT } from '../../../../shared/constants';
import PartnerWorkConfiguation = Boo.Objects.Work.PartnerWorkConfiguration;
import PartnerTaskTypeAllocation = Boo.Objects.Work.PartnerTaskTypeAllocation;
import SeoWorkTaskType = Boo.Objects.Work.SeoMinute.SeoWorkTaskType;

@Component({
  selector: 'app-components-manager-partner-task-type-allocations',
  templateUrl: './partner-task-type-allocations.component.html',
  styleUrls: ['./partner-task-type-allocations.component.scss']
})
export class PartnerTaskTypeAllocationsComponent implements OnInit {
  @Input() isReadOnly: boolean;
  @Input() hours: number;
  @Input() partnerId: number;
  @Input() partnerWorkConfiguration: PartnerWorkConfiguation;
  @Input() taskTypes: SeoWorkTaskType[];
  @Input() unallocatedMinutes: number;
  @Output() removeHourAllocation: EventEmitter<number> = new EventEmitter<number>();
  minutes: number;
  qtyNumbers: number[];

  ngOnInit(): void {
    this.minutes = this.hours * 60;
    this.qtyNumbers = Array.from({length: DEFAULT_MAX_TASK_COUNT + 1}, (_, i) => i);
  }

  addTaskTypeAllocation(taskType: SeoWorkTaskType): void {
    const existingTaskTypeIds = this.taskTypeAllocations.map(x => x.TaskTypeId);
    if (existingTaskTypeIds.includes(taskType.TaskTypeId)) {
      const existingTaskType = this.taskTypeAllocations.find(x => x.TaskTypeId === taskType.TaskTypeId);
      existingTaskType.TaskCount++;
    } else {
      const newItem = this.createTaskTypeAllocation(taskType);
      this.partnerWorkConfiguration.TaskTypeAllocations.push(newItem);
    }
  }

  deleteAllocation(): void {
    const msg = `Are you sure you want do delete allocations for ${ this.hours } ${ this.hours > 1 ? 'hours' : 'hour'}?`;
    bootbox.confirm(msg, (result: boolean) => {
        if (result === true) {
          this.removeHourAllocation.emit(this.hours);
        }
    });
  }

  get isAllocationValid(): boolean {
    return this.allocatedMinutes <= this.minutes;
  }

  get allocatedMinutes(): number {
    return this.unallocatedMinutes + (this.taskTypeAllocations.length ? this.taskTypeAllocations.map(item => item.TaskType.BillableMinutes * item.TaskCount).reduce((a, b) => a + b, 0) : 0);
  }

  get minuteDifferenceMessage(): string {
    if (this.minutes > this.allocatedMinutes) {
      return `${ this.minutes - this.allocatedMinutes } Under`;
    } else {
      return `${ this.allocatedMinutes - this.minutes } Over`;
    }
  }

  get showTable(): boolean {
    return this.taskTypeAllocations?.some(x => x.TaskCount);
  }

  get taskTypeAllocations(): PartnerTaskTypeAllocation[] {
    return this.partnerWorkConfiguration.TaskTypeAllocations
    .sort((a, b) => a.TaskType.Name.localeCompare(b.TaskType.Name))
    .sort((a, b) => a.TaskType.BillableMinutes - b.TaskType.BillableMinutes);
  }

  private createTaskTypeAllocation(taskType: Boo.Objects.Work.SeoMinute.SeoWorkTaskType): PartnerTaskTypeAllocation {
    return {
      PartnerWorkConfigurationId: this.partnerWorkConfiguration.PartnerWorkConfigurationId,
      PartnerTaskTypeAllocationId: 0,
      TaskTypeId: taskType.TaskTypeId,
      TaskType: {
        Name: taskType.Name,
        Description: taskType.Description,
        BillableMinutes: taskType.Minutes
      } as Boo.Objects.TaskType,
      TaskCount: 1,
      MinutesPerTask: taskType.Minutes,
    }
  }
}
